const OWN_IMAGE_HOST_MARKERS = ["klearly-media-uploads"];

export function isRehostableImageSrc(src: string | null | undefined): boolean {
  if (!src) return false;
  if (src.startsWith("data:image/")) return true;
  if (!/^https?:\/\//i.test(src)) return false;
  return !OWN_IMAGE_HOST_MARKERS.some((marker) => src.includes(marker));
}

export function filenameFromSrc(
  src: string,
  fallback = "pasted-image"
): string {
  if (src.startsWith("data:")) {
    const subtype = /^data:image\/([a-z0-9.+-]+)/i.exec(src)?.[1] ?? "png";
    return `${fallback}.${subtype === "jpeg" ? "jpg" : subtype}`;
  }
  try {
    const name = new URL(src).pathname.split("/").pop() ?? "";
    return name.includes(".") ? name : `${fallback}.png`;
  } catch {
    return `${fallback}.png`;
  }
}

export function dataUrlToFile(dataUrl: string, filename: string): File {
  const commaIndex = dataUrl.indexOf(",");
  const meta = dataUrl.slice(0, commaIndex);
  const payload = dataUrl.slice(commaIndex + 1);
  const mime = /data:([^;]+)/.exec(meta)?.[1] ?? "image/png";
  const binary = /;base64/i.test(meta)
    ? atob(payload)
    : decodeURIComponent(payload);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new File([bytes], filename, { type: mime });
}

export function imageFilesFromClipboard(
  data: Pick<DataTransfer, "files"> | null | undefined
): File[] {
  if (!data?.files) return [];
  return Array.from(data.files).filter((file) =>
    file.type.startsWith("image/")
  );
}
